module.exports = "/static/Images/es/One.png";